import { Turbo } from "@hotwired/turbo-rails";

function modalElement(stream) {
  return document.getElementById(stream.getAttribute("target"));
}

function isSprintModalV2(element) {
  return Boolean(element?.classList.contains("sprint-modal-v2"));
}

function closeSprintModalV2(element) {
  element.classList.remove("is-open", "in", "show");
  element.style.removeProperty("display");

  if (!document.querySelector(".sprint-modal-v2.is-open, .sprint-modal-v2.in, .modal.in")) {
    if (typeof window.jQuery !== "undefined") {
      window.jQuery(".modal-backdrop").remove();
      window.jQuery("body").removeClass("modal-open");
    }
    document.body.style.removeProperty("padding-right");
  }

  element.dispatchEvent(new CustomEvent("modal:closed", {
    bubbles: true,
    detail: { modalId: element.id },
  }));
}

function showSprintModalV2(element) {
  element.classList.add("is-open");
}

function bootstrapModal(element, action) {
  if (!element || typeof window.jQuery === "undefined") {
    return;
  }

  const $element = window.jQuery(element);
  if (typeof $element.modal === "function") {
    $element.modal(action);
  }
}

Turbo.StreamActions.show_modal = function showModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    showSprintModalV2(element);
    return;
  }

  bootstrapModal(element, "show");
};

Turbo.StreamActions.hide_modal = function hideModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    closeSprintModalV2(element);
    return;
  }

  bootstrapModal(element, "hide");
};

Turbo.StreamActions.dispose_modal = function disposeModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    closeSprintModalV2(element);
    return;
  }

  bootstrapModal(element, "dispose");
};
